<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Uvoz stavki</h5>
            </div>
            <div class="ibox-content">
                <skup-stavka-import-excel-form
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                >
                </skup-stavka-import-excel-form>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupStavkaImportExcelForm from "./SkupStavkaImportExcelForm";
export default {
    name: "SkupStavkaCreate",
    components: { SkupStavkaImportExcelForm, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/stavke',
                    name: 'Stavke'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/stavke',
                    name: 'Uvoz stavki'
                }
            ]
        }
    },
    mounted() {
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
